export const RATE_BROWSER = 'rate-browser';
export const CUSTOMERS_CREATE_LABEL = 'customers-create-label';
export const SIMPLE_LABEL_FLOW = 'simple-label-flow';
export const EPHEMERAL_FULFILLMENT_PLAN_IDS = [RATE_BROWSER, CUSTOMERS_CREATE_LABEL];
